/* Shared, side-effect-free cart matching for the frame and mounting offers. */
window.DcCartPairing = window.DcCartPairing || (function () {
  function size(item) {
    var value = String(item && (item.variant_title || item.title) || '').toLowerCase();
    if (/\ba\s*4\b/.test(value)) return 'a4';
    var dimensions = value.match(/(\d{2,3})\s*(?:x|×)\s*(\d{2,3})/);
    if (!dimensions) return '';
    return [Number(dimensions[1]), Number(dimensions[2])].sort(function (a, b) { return a - b; }).join('x');
  }

  function match(cart, frameProductIds, serviceVariantId) {
    var items = cart.items || [];
    var frameHandles = new Set(['oak-frame', 'dark-oak-frame', 'black-wooden-frame', 'white-wooden-frame']);
    var isFrame = function (item) {
      var type = String(item.product_type || '').toLowerCase();
      return frameProductIds.has(item.product_id) || frameHandles.has(item.handle) ||
        type === 'frame' || type === 'ram' || type === 'marco';
    };
    var prints = items.filter(function (item) {
      return item.variant_id !== serviceVariantId && !isFrame(item) && item.product_type !== 'Service';
    });
    var frames = items.filter(function (item) { return isFrame(item); });
    var services = items.filter(function (item) { return item.variant_id === serviceVariantId; });
    var claimedPrints = new Map();
    var claimedFrames = new Map();
    var claimedServices = new Map();
    var pairs = [];

    function claim(print, frame, source) {
      if (!print || !frame || !size(print) || size(print) !== size(frame)) return false;
      if ((claimedPrints.get(print.key) || 0) >= print.quantity) return false;
      if ((claimedFrames.get(frame.key) || 0) >= frame.quantity) return false;
      claimedPrints.set(print.key, (claimedPrints.get(print.key) || 0) + 1);
      claimedFrames.set(frame.key, (claimedFrames.get(frame.key) || 0) + 1);
      var service = services.find(function (item) {
        if ((claimedServices.get(item.key) || 0) >= item.quantity) return false;
        var p = item.properties || {};
        return (p._frame_key === frame.key && p._print_key === print.key) ||
          (source === 'legacy' && p._pair && p._pair === print.properties._pair);
      });
      if (service) claimedServices.set(service.key, (claimedServices.get(service.key) || 0) + 1);
      pairs.push({ print: print, frame: frame, service: service || null, source: source });
      return true;
    }

    // Honor a product-page pair first, then a frame added from the cart.
    frames.forEach(function (frame) {
      var token = frame.properties && frame.properties._pair;
      if (token) claim(prints.find(function (print) {
        return print.properties && print.properties._pair === token;
      }), frame, 'legacy');
    });
    frames.forEach(function (frame) {
      if ((claimedFrames.get(frame.key) || 0) >= frame.quantity) return;
      var key = frame.properties && frame.properties._print_key;
      if (key) claim(prints.find(function (print) { return print.key === key; }), frame, 'linked');
    });

    // Loose items are paired only when the size identifies one possible print.
    frames.forEach(function (frame) {
      if (frame.properties && (frame.properties._pair || frame.properties._print_key)) return;
      while ((claimedFrames.get(frame.key) || 0) < frame.quantity) {
        var candidates = prints.filter(function (print) {
          return size(print) && size(print) === size(frame) &&
            (claimedPrints.get(print.key) || 0) < print.quantity;
        });
        if (candidates.length !== 1 || !claim(candidates[0], frame, 'loose')) break;
      }
    });

    return {
      prints: prints,
      frames: frames,
      services: services,
      serviceCounts: claimedServices,
      pairs: pairs,
      unframed: prints.filter(function (print) {
        return size(print) && (claimedPrints.get(print.key) || 0) < print.quantity;
      }),
      size: size
    };
  }
  return { size: size, match: match };
})();
